import { render, staticRenderFns } from "./privacyPolicyList.vue?vue&type=template&id=b5ebdbbc&scoped=true&"
import script from "./privacyPolicyList.vue?vue&type=script&lang=js&"
export * from "./privacyPolicyList.vue?vue&type=script&lang=js&"
import style0 from "./privacyPolicyList.vue?vue&type=style&index=0&id=b5ebdbbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ebdbbc",
  null
  
)

export default component.exports